import React from 'react';
import OptimizedImage from '../../ui/OptimizedImage';
import NoteoriousThumb from './NoteoriousThumb';
import AiChatThumb from './AiChatThumb';
import LexifaiThumb from './LexifaiThumb';
import SecurityThumb from './SecurityThumb';
import HandwritingThumb from './HandwritingThumb';
import AiTemplateThumb from './AiTemplateThumb';
import AnimatedBgThumb from './AnimatedBgThumb';
import IpLoggingThumb from './IpLoggingThumb';
import NeuralAccelThumb from './NeuralAccelThumb';
import NlpApiThumb from './NlpApiThumb';
import TerminalThumb from './TerminalThumb';

/** slug -> custom illustrated thumbnail. Keyed by the slugs in src/data/projects.ts. */
export const projectThumbs: Record<string, React.FC> = {
  'modern-notes-app': NoteoriousThumb,
  'ai-powered-projects-chat-system': AiChatThumb,
  'lexifai-ocr-chatbot': LexifaiThumb,
  'website-security-implementation': SecurityThumb,
  'handwriting-recognition': HandwritingThumb,
  'ai-template-generator': AiTemplateThumb,
  'animated-background-system': AnimatedBgThumb,
  'ip-logging-system': IpLoggingThumb,
  'neural-network-accelerator': NeuralAccelThumb,
  'nlp-api': NlpApiThumb,
  'interactive-terminal-system': TerminalThumb,
};

interface ProjectThumbProps {
  slug: string;
  title: string;
  image: string;
  className?: string;
}

/**
 * Renders a project's custom illustrated thumbnail (white canvas, #121110 ink),
 * falling back to its screenshot when no illustration is registered for the slug.
 */
const ProjectThumb: React.FC<ProjectThumbProps> = ({ slug, title, image, className }) => {
  const Thumb = projectThumbs[slug];
  if (Thumb) {
    return (
      <div className={`w-full h-full bg-white ${className || ''}`}>
        <Thumb />
      </div>
    );
  }
  return <OptimizedImage src={image} alt={title} className={className || 'w-full h-full object-cover'} />;
};

export default ProjectThumb;
